import React from 'react';
import ReactDom from 'react-dom';

const debug = false; // Enable this variable to get more info about mounting components

/**
 * @author Bastien Ladron
 * This class helps to work with React applications that can depends of other React applications.
 * It gives tools to render application when it is possible, to have booters in global variable in order to launch an application from other javascript code.
 */
export default class ReactBoot {
    /**
     * Render the given component type if the expected div exists.
     * No error will be thrown if the div doesn't exist.
     * @param componentType The component type which we want to render
     * @param divId The div's id where the component is expected to be rendered
     * @param props props to be passed to the component
     * @param ssr {boolean} optimized for server-side rendering
     */
    static tryBoot(componentType, divId, props = {}, ssr = false) {
        let element = React.createElement(componentType, props);
        let expectedDiv = document.getElementById(divId);

        if (expectedDiv) {
            if(ssr) {
                ReactDom.hydrate(element, expectedDiv);
            } else {
                ReactDom.render(element, expectedDiv);
            }
            return true;
        } else {
            if(debug) {
                console.log(`Cannot mount React on ${divId}, tag doesn't exist in the page. This could be a desired behavior (ex: a component that should not be necessary mounted)`)
            }
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./js/mywort/commons/utils/ReactBoot.js